@if (!countriesIsLoading) {
  <korviu-select
    label="{{ 'auth.signup.country' | translate }}"
    class="flex-1"
    [control]="control"
    [options]="countries"
    [showErrorMessagesUnderField]="true"
  ></korviu-select>
}
@if (countriesIsLoading) {
  <nz-spin class="mt-4"></nz-spin>
}
